import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ClientOnlyFsLightbox from './../block/ClientOnlyFsLightbox'

import { Container, Image } from 'react-bootstrap'

import { FreeMode, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      toggler: false,
      slide: 1
    }
  }

  changeTogle = ( val, i ) => {
    this.setState({
      toggler: val,
      slide: i
    })
  }

  render() {

    const { shop } = this.props,
    { toggler, slide } = this.state

    if(shop != null) return (
      <div className={styles.shop_gallary}>
        <Container>
          <div className={styles.shopsng_gallary_title}>{shop.name}</div>
          {'images' in shop &&
            <>
              <Swiper
                modules={[FreeMode, Pagination]}
                pagination={{ type: `progressbar` }}
                spaceBetween={6}
                slidesPerView={`auto`}
                freeMode={true}
                className={styles.recomendedng_slyder_prod}
                speed={300}
              >
                {shop.images.map( ( image, i ) => {
                  return (
                    <SwiperSlide className={styles.shop_gallary_el} key={i}>
                      <Image onClick={() => this.changeTogle( !toggler, i + 1 )} className='mb-2' src={image} height={359} />
                    </SwiperSlide>
                  )
                })}
              </Swiper>
              <ClientOnlyFsLightbox
                toggler={toggler}
                sources={shop.images}
                slide={slide}
              />
            </>
          }
        </Container>
      </div>
    )

    return (
      <></>
    )
  }
}

Main.propTypes = {
  shop: PropTypes.object
}